import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputBase from '@mui/material/InputBase';
import Stack from '@mui/material/Stack';
import CardContent from '@mui/material/CardContent';
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Tooltip, IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { Link } from 'react-router-dom';
// import Navbar from '../../../Navbar';
import Footer from '../../../Footer';
import HRNavbar from '../HRNavbar';

const empList = [
    {
        id: 1,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 2,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 3,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 4,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 5,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 6,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 7,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 8,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 9,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 10,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 11,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
    {
        id: 12,
        name: 'Ashmita Shinde',
        avatarSrc: '/static/images/avatar/3.jpg',
        code: 'IHPF000781',
        role: 'Physiotherapist',
        phone: '+91 | 9999999999',
        location: 'Katraj, Pune Maharashtra',
    },
];

const Employee = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    return (
        <>
            <HRNavbar style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000 }} />
            <Box sx={{ flexGrow: 1, mt: 1, ml: 1, mr: 1, }}>
                <Stack direction={isSmallScreen ? 'column' : 'row'}
                    spacing={1}
                    alignItems={isSmallScreen ? 'center' : 'flex-start'}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600, marginTop: "10px", marginLeft: "10px" }} color="text.secondary" gutterBottom>EMPLOYEE LIST</Typography>

                    <Box
                        component="form"
                        sx={{ marginLeft: '2rem', p: "2px 4px", display: 'flex', alignItems: 'center', width: 260, height: '2.2rem', backgroundColor: "#ffffff", boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)", borderRadius: "10px", border: "1px solid #C9C9C9" }}
                    >
                        <IconButton type="button" sx={{ color: "#69A5EB", height: "36px", width: "36px" }}>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            sx={{ ml: 1, flex: 1, }}
                            placeholder="Search Employee |"
                        // value={selectedService}
                        // onChange={handleServiceChange}
                        />
                    </Box>
                    <Box
                        component="form"
                        sx={{ marginLeft: '2rem', p: "2px 4px", display: 'flex', alignItems: 'center', width: 260, height: '2.2rem', backgroundColor: "#ffffff", boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)", borderRadius: "10px", border: "1px solid #C9C9C9" }}
                    >
                        <IconButton type="button" sx={{ color: "#69A5EB", height: "36px", width: "36px" }}>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            sx={{ ml: 1, flex: 1, }}
                            placeholder="Search Servive |"
                        // value={selectedService}
                        // onChange={handleServiceChange}
                        />
                    </Box>
                    <Button variant='contained' sx={{ background: "#69A5EB", textTransform: "capitalize", borderRadius: "8px", width: "12ch" }}>View</Button>
                </Stack >
                <Grid item xs={12} container spacing={1} sx={{ mt: 1, mb: 3 }}>
                    {empList.map((card) => (
                        <Grid item xs={12} sm={6} lg={3}>
                            <Box sx={{ background: "#FFFFFF", borderRadius: "6px", padding: '6px' }}>
                                <div style={{ display: "flex" }}>
                                    <div>
                                        <Avatar alt="Ashmita Shinde" src={card.avatarSrc} />
                                        <Typography variant='body2' sx={{ mt: 1 }}>{card.code}</Typography>
                                    </div>
                                    <Box sx={{ borderLeft: '1px solid #767676', height: '100px', mx: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} />
                                    <div>
                                        <Typography variant='subtitle2' >{card.name}</Typography>
                                        <Typography variant='body2' >{card.role}</Typography>
                                        <Typography variant='body2' >{card.phone}</Typography>
                                        <Box sx={{ borderBottom: '1px solid #767676', width: '150px', mr: 2, mt: 1, mb: 1 }} />
                                        <div style={{ display: "flex" }}>
                                            <FmdGoodOutlinedIcon sx={{ fontSize: "18px", color: "#69A5EB" }} />
                                            <Typography variant='body2' sx={{ ml: 1 }}>{card.location}</Typography>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box >
            <Footer />
        </>
    )
}

export default Employee
